import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-notvisible",
  templateUrl: "./field-set-notvisible.component.html",
  styles: [],
})
export class FieldSetNotVisibleComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
